module.exports = __webpack_public_path__ + "static/media/6_raspberry_candy_small.44abbb7c.jpg";